<template>
  <div class="newView">
    <div class="indexData">
      <div class="item-box">
        <div class="itemImg1" v-bind:style="{backgroundImage:'url(http://video.naolamp.com/images/index/service_1.jpg)',
                  backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
        </div>
        <div class="itemImg2" v-bind:style="{backgroundImage:'url(http://video.naolamp.com/images/index/service_2.jpg)',
                  backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
        </div>
        <div class="itemImg3" v-bind:style="{backgroundImage:'url(http://video.naolamp.com/images/index/service_3.jpg)',
                  backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
        </div>
      </div>
    </div>
    <!--<div class="footer">-->
      <!--<p>注：激活质保前需要关注 “车灯师服务号” 公众号，已过质保期的车主不能享受该售后</p>-->
    <!--</div>-->
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </div>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  name: 'userMain',
  data () {
    return {
      msg: '质保售后',
      isLoad: true
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.isLoad = false
  },
  methods: {
  },
  filters: {
  },
  components: {
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newView{
  background-color: #eee;
}
.indexData {
  margin-top: 50px;
  border-top: 1px solid #F0F0F0;
  text-align: center;
  width: 100%;
}
.item-box{
  list-style: none;
  text-align: center;
}
.item-box div{
  max-width: 1920px;
  margin:0 auto;
}
.itemImg1 {
  height: 615px;
}
.itemImg2 {
  height: 616px;
}
.itemImg3 {
  height: 718px;
}
.footer{
  width: 100%;
  height: 80px;
  line-height: 80px;
}
.footer>p{
  text-align: center;
  font-size: 16px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/service/serviceMain.vue